<template>
  <div>
    <ul class="newslist">
      <router-link
        :to='id +"/"+slide.id'
        v-for="(slide,index) in swiperSlides"
        :key="index"
        class="newsitem"
        tag="li"
      >
        <div class="imgbox">
          <img :src="'/static/uploads/'+slide.img" />
        </div>

        <h3>{{slide.title}}</h3>
        <p>{{slide.content | capitalize}}</p>
        <p style='margin-top: 10px; font-size: 22px; text-align: right;'>发布时间：{{slide.time}}</p>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["swiperSlides", "id"],
  data() {
    return {};
  },
  components: {},
  filters:{
    capitalize(val){
      let reg= /&nbsp;/g
      return val.replace(reg,'')
    }   
  }
};
</script>

<style>
</style>